import type { FC } from 'react'

import { InfoBox } from '@skytech/ui'

import Text from '@/app/translations/Text'
import { LocalDate } from '@/components/LocalDate'
import { useInjuryReportForm } from '@/forms/hooks'

import './AssetDescription.styles.scss'

const AssetDescription: FC = () => {
  const { data } = useInjuryReportForm()
  const { assetDescription, assetImeiSnr, assetReceivedDate } = data

  return (
    <section className="asset-description">
      <InfoBox>
        <div className="asset-description-info">
          <p className="asset-description__description">{assetDescription}</p>

          {assetImeiSnr && assetReceivedDate && (
            <p className="asset-description__imei-snr">
              <Text
                id="{imeiSnr}, mottatt: {receivedDate}"
                imeiSnr={assetImeiSnr}
                receivedDate={<LocalDate date={assetReceivedDate} />}
              />
            </p>
          )}
        </div>
      </InfoBox>
    </section>
  )
}
export default AssetDescription
